

export const treeProps = {
    children: 'children',
    label: 'name'
};